
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockDisassembleDtDialog extends Serenity.EntityDialog<IcStockDisassembleDtRow, any> {
        protected getFormKey() { return IcStockDisassembleDtForm.formKey; }
        // protected getIdProperty() { return IcStockDisassembleDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockDisassembleDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockDisassembleDtRow.nameProperty; }
        // protected getService() { return IcStockDisassembleDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockDisassembleDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockDisassembleDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockDisassembleDtRow.updatePermission; }

        protected form = new IcStockDisassembleDtForm(this.idPrefix);

    }
}